var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.764,
    height: 21.491,
    viewBox: "0 0 22.764 21.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_395",
    "data-name": "Grupo 395",
    transform: "translate(-0.023 -0.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_396",
    "data-name": "Grupo 396",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_555",
    "data-name": "Trazado 555",
    d: "M22.245,4.214V19.275A1.521,1.521,0,0,1,20.721,20.8H2.015A1.53,1.53,0,0,1,.481,19.275V4.214A1.533,1.533,0,0,1,2.015,2.68H20.721A1.523,1.523,0,0,1,22.245,4.214Z",
    transform: "translate(0.042 0.237)",
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_556",
    "data-name": "Trazado 556",
    d: "M15.77,1.991v.881H1.961V1.991A1.667,1.667,0,0,1,3.767.5H13.975A1.663,1.663,0,0,1,15.77,1.991Z",
    transform: "translate(0.173 0.044)",
    fill: "none",
    stroke: "gray",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.369d1ebe2b9b5af636af758b9cdb9111.svg";
export { ForwardRef as ReactComponent };